import { lazy } from 'react';

export default lazy(
  () =>
    import(
      /* webpackChunkName: "home-view" */
      './Home'
    )
);
